(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var savedScroll = 0;
    function openDrawer() {
      savedScroll = window.scrollY;
      drawer.classList.add('is-open');
      document.body.style.position = 'fixed';
      document.body.style.top = (-savedScroll) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, savedScroll);
    }

    function updateCount(count) {
      var badge = document.querySelector('.header__cart-count');
      if (badge) { badge.textContent = count; badge.style.display = count > 0 ? '' : 'none'; }
    }

    function rerender(sections) {
      if (!sections || !sections['cart-drawer']) return;
      var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var next = parsed.querySelector('#cart-drawer-content');
      var current = document.querySelector('#cart-drawer-content');
      if (next && current) current.replaceWith(next);
    }

    // Open from the header cart icon
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: qtyBtn.dataset.key, quantity: Number(qtyBtn.dataset.qty), sections: 'cart-drawer', sections_url: location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCount(cart.item_count); rerender(cart.sections); });
      }
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    // Intercept add-to-cart submissions
    document.addEventListener('submit', function (e) {
      var form = e.target;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var idField = form.querySelector('[name="id"]');
      if (!idField || !idField.value) return;
      var qtyField = form.querySelector('[name="quantity"]');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: idField.value, quantity: Number(qtyField && qtyField.value || 1), sections: 'cart-drawer', sections_url: location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) return; // error (e.g. sold out)
          rerender(res.sections);
          openDrawer();
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            updateCount(cart.item_count);
          });
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.header');
    if (!header) return;
    // Full-screen panel homepage: header stays transparent over every panel.
    if (document.querySelector('.hero-slider-section')) {
      header.classList.add('header--over-hero');
      return;
    }
    // Single hero with content below: transparent over the hero, solid once scrolled past.
    if (!document.querySelector('.hero-section')) return;
    function update() {
      if (window.scrollY < 60) header.classList.add('header--over-hero');
      else header.classList.remove('header--over-hero');
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('.hero-slider');
    if (!el) return;

    // Move the theme footer into the slider as a final full-screen panel,
    // so it snaps like the others and the page never scrolls.
    var footer = document.querySelector('.shopify-section-group-footer-group');
    var wrapper = el.querySelector('.swiper-wrapper');
    if (footer && wrapper && !el.dataset.footerMoved) {
      el.dataset.footerMoved = '1';
      var fslide = document.createElement('div');
      fslide.className = 'swiper-slide hero-slide hero-slide--footer';
      fslide.appendChild(footer);
      wrapper.appendChild(fslide);
    }

    var tries = 0;
    function init() {
      if (!window.Swiper) {
        if (tries++ < 100) setTimeout(init, 50);
        return;
      }
      if (el.dataset.inited) return;
      el.dataset.inited = '1';
      var desktop = window.matchMedia('(min-width: 750px)').matches;
      var opts = {
        direction: desktop ? 'vertical' : 'horizontal',
        speed: 450,
        parallax: true,
        loop: false,
        keyboard: { enabled: true },
        effect: el.dataset.effect || 'slide',
        pagination: { el: el.querySelector('.swiper-pagination'), clickable: true }
      };
      // No releaseOnEdges: the footer is the last panel, so the wheel never scrolls the page.
      if (desktop) opts.mousewheel = { thresholdDelta: 6 };
      if (opts.effect === 'fade') opts.fadeEffect = { crossFade: true };
      if (el.dataset.autoplay === 'true') {
        opts.autoplay = { delay: Number(el.dataset.interval) || 6000, disableOnInteraction: false };
      }
      new Swiper(el, opts);
    }
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-recommendations]');
    if (!el || !el.dataset.url || el.dataset.loaded) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('[data-recommendations]');
        if (next) { next.dataset.loaded = 'true'; el.replaceWith(next); }
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add]');
    var mainImg = root.querySelector('[data-main-image]');

    function swapMedia(mediaId) {
      if (!mediaId || !mainImg) return;
      var thumb = root.querySelector('[data-media-id="' + mediaId + '"]');
      if (thumb) {
        mainImg.removeAttribute('srcset');
        mainImg.src = thumb.getAttribute('data-full');
      }
    }

    root.querySelectorAll('input[name="id"][data-variant]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
        var available = radio.dataset.available === 'true';
        if (addBtn) {
          addBtn.disabled = !available;
          addBtn.textContent = available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
        }
        swapMedia(radio.dataset.media);
      });
    });

    root.querySelectorAll('[data-media-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.src = btn.getAttribute('data-full');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
